import axios from "./axios";

export async function fetchJobApplications(controller = {}) {
  const { job_opening_id, ...params } = controller || {};
  const url = job_opening_id
    ? `/job_openings/${job_opening_id}/job_applications`
    : "/job_applications";
  return axios({ method: "get", url, params })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function fetchJobApplication(id) {
  return axios({ method: "get", url: `/job_applications/${id}` })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function createJobApplication(payload) {
  const openingId = payload.job_opening_id;
  const url = openingId
    ? `/job_openings/${openingId}/job_applications`
    : "/job_applications";
  return axios
    .post(url, { job_application: payload })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function updateJobApplication(payload) {
  return axios
    .put(`/job_applications/${payload.id}`, { job_application: payload })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}

export async function deleteJobApplication(id) {
  return axios
    .delete(`/job_applications/${id}`)
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: true });
}
